import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const gwiLocationTypesAdapter = getAdapter({ idFieldName: 'value' });

const gwiLocationTypesSlice = createSlice({
  name: 'gwiLocationTypes',
  initialState: gwiLocationTypesAdapter.getInitialState(),
  reducers: {
    setGwiLocationTypes: (state, { payload: { gwiLocationTypes } }) => {
      gwiLocationTypesAdapter.setAll(state, gwiLocationTypes);
    }
  }
});

const selectors = gwiLocationTypesAdapter.getSelectors(({ gwiLocationTypes }) => gwiLocationTypes);

export const getGwiLocationTypes = state => selectors.selectAll(state);

export const { setGwiLocationTypes } = gwiLocationTypesSlice.actions;

export default gwiLocationTypesSlice.reducer;
